import { render } from "./Payment.modal.vue?vue&type=template&id=7310a6fb"
import script from "./Payment.modal.vue?vue&type=script&lang=js"
export * from "./Payment.modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__